module.exports = __webpack_public_path__ + "static/devops-df96077b7916a47a419f5f02f74f6025.jpg";